import { ErrorExclamation } from "@monsterindia/global-ui-components";

const ErrorMessage = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center gap-1">
      <ErrorExclamation width={13} height={13} className="fill-red-500" />
      <p className="text-xs text-red-500">{text}</p>
    </div>
  );
};

export default ErrorMessage;
